import React, { useState } from 'react';
import { useFirestore } from '../hooks/useFirestore';

const ReviewForm = ({ providerId }) => {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const { addReview } = useFirestore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addReview(providerId, { rating, comment });
      setRating(5);
      setComment('');
      // Mostrar mensaje de éxito
    } catch (error) {
      console.error('Error al enviar la reseña:', error);
      // Manejar error
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="rating" className="block mb-2">Calificación</label>
        <select
          id="rating"
          value={rating}
          onChange={(e) => setRating(Number(e.target.value))}
          className="w-full p-2 border rounded-md"
        >
          {[1, 2, 3, 4, 5].map((num) => (
            <option key={num} value={num}>{num} estrellas</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="comment" className="block mb-2">Comentario</label>
        <textarea
          id="comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="w-full p-2 border rounded-md"
          rows="4"
          required
        ></textarea>
      </div>
      <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
        Enviar Reseña
      </button>
    </form>
  );
};

export default ReviewForm;